import { getLocale } from "../runtime";

const sv_eecountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Estland`
};

const eecountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_eecountry(inputs)
	return "eeCountry";
};

export { eecountry as "eeCountry" };